module.exports = __webpack_public_path__ + "static/media/G1-10-Alana Dimitris-cod30-B.c5268138.png";